import { ApplicationController } from "../application_controller"
import Tabulator from "tabulator-tables"

const createCalc = (tableId, attrName, defaultVal) => (_values, _data, _calcParams) => {
  const tbl = document.getElementById(tableId);
  if (!tbl) return defaultVal;
  return tbl.getAttribute(attrName) || defaultVal;
};

const calcConfigs = [
  { name: "zReportExpensesTotal",            table: "expenses_table", attr: "data-total-text",          defaultVal: ""  },
  { name: "zReportIncomeTotal",              table: "income_table",   attr: "data-total-text",          defaultVal: ""  },
  { name: "zReportExpensesTotalUSD",         table: "expenses_table", attr: "data-total-usd",           defaultVal: "0" },
  { name: "zReportExpensesTotalUZS",         table: "expenses_table", attr: "data-total-uzs",           defaultVal: "0" },
  { name: "zReportExpensesTotalEUR",         table: "expenses_table", attr: "data-total-eur",           defaultVal: "0" },
  { name: "zReportExpensesTotalRUB",         table: "expenses_table", attr: "data-total-rub",           defaultVal: "0" },
  { name: "zReportExpensesTotalUSDConverted",table: "expenses_table", attr: "data-total-usd-converted", defaultVal: "0" },
  { name: "zReportIncomeTotalUSD",           table: "income_table",   attr: "data-total-usd",           defaultVal: "0" },
  { name: "zReportIncomeTotalUZS",           table: "income_table",   attr: "data-total-uzs",           defaultVal: "0" },
  { name: "zReportIncomeTotalEUR",           table: "income_table",   attr: "data-total-eur",           defaultVal: "0" },
  { name: "zReportIncomeTotalRUB",           table: "income_table",   attr: "data-total-rub",           defaultVal: "0" },
  { name: "zReportIncomeTotalUSDConverted",  table: "income_table",   attr: "data-total-usd-converted", defaultVal: "0" },
];

const calculations = {};
calcConfigs.forEach(({ name, table, attr, defaultVal }) => {
  calculations[name] = createCalc(table, attr, defaultVal);
});

Tabulator.prototype.extendModule("columnCalcs", "calculations", calculations);


export default class extends ApplicationController {
  static targets = ["dateRange", "exportUrl", "walletBalanceTable", "expensesTable", "incomeTable", "conversionsTable"]
  static values = { dateRange: String }

  connect() {
    // Initialize debounced function and state
    this.updateTableFiltersDebounced = this.debounce(this.updateTableFilters.bind(this), 300)
    this.lastDateRange = null
    
    if (this.hasWalletBalanceTableTarget) {
      this.createWalletBalanceTable()
    }
    
    if (this.hasExpensesTableTarget) {
      this.createExpensesTable()
    }

    if (this.hasIncomeTableTarget) {
      this.createIncomeTable()
    }

    if (this.hasConversionsTableTarget) {
      this.createConversionsTable()
    }
  }

  createWalletBalanceTable() {
    const table_target = this.walletBalanceTableTarget
    const url = table_target.getAttribute("data-table-load-url")
    const columns = this.getWalletBalanceColumns()
    const default_props = this.tabulatorDefaultProps
    const height = document.getElementById('content').clientHeight
    const sort_column = table_target.getAttribute("data-sort-column")
    const sort_dir = table_target.getAttribute("data-sort-dir")

    let table_props = {
      persistenceID: "z_report_wallet_balance_table",
      layout: "fitDataTable",
      height: (height - 150) + "px",
      movableColumns: true,
      initialSort: [
        { column: sort_column, dir: sort_dir }
      ],
      // columns
      columns: columns,
      // pagination
      pagination: "local",
      paginationSize: 25,
      paginationSizeSelector: [10, 25, 50],
      // Ajax
      ajaxURL: url,
      ajaxSorting: true,
      ajaxFiltering: true,
      ajaxLoader: true,
      ajaxLoaderLoading: "<div class='loader'> Loading...</div>"
    }

    table_props = Object.assign(default_props, table_props)
    // create table
    table_target.tabulator = new Tabulator(table_target, table_props)
    table_target.tabulator.setLocale(this.appLocale)
  }

  getWalletBalanceColumns() {
    const columnsData = this.walletBalanceTableTarget.getAttribute("data-table-columns")
    return JSON.parse(columnsData)
  }

  createExpensesTable() {
    const table_target = this.expensesTableTarget
    const url = table_target.getAttribute("data-table-load-url")
    const columns = this.getExpensesColumns()
    const default_props = this.tabulatorDefaultProps
    const height = document.getElementById('content').clientHeight
    const sort_column = table_target.getAttribute("data-sort-column")
    const sort_dir = table_target.getAttribute("data-sort-dir")

    let table_props = {
      persistenceID: "z_report_expenses_table",
      layout: "fitDataTable",
      height: (height - 150) + "px",
      movableColumns: true,
      initialSort: [
        { column: sort_column, dir: sort_dir }
      ],
      // columns
      columns: columns,
      // pagination
      pagination: "local",
      paginationSize: 25,
      paginationSizeSelector: [10, 25, 50],
      // Ajax
      ajaxURL: url,
      ajaxSorting: true,
      ajaxFiltering: true,
      ajaxLoader: true,
      ajaxLoaderLoading: "<div class='loader'> Loading...</div>",
      ajaxResponse: (url, params, response) => {
        this.updateExpenseTotals(response)
        return response.data || response
      }
    }

    table_props = Object.assign(default_props, table_props)
    // create table
    table_target.tabulator = new Tabulator(table_target, table_props)
    table_target.tabulator.setLocale(this.appLocale)
  }

  getExpensesColumns() {
    const columnsData = this.expensesTableTarget.getAttribute("data-table-columns")
    return JSON.parse(columnsData)
  }

  createIncomeTable() {
    const table_target = this.incomeTableTarget
    const url = table_target.getAttribute("data-table-load-url")
    const columns = this.getIncomeColumns()
    const default_props = this.tabulatorDefaultProps
    const height = document.getElementById('content').clientHeight
    const sort_column = table_target.getAttribute("data-sort-column")
    const sort_dir = table_target.getAttribute("data-sort-dir")

    let table_props = {
      persistenceID: "z_report_income_table",
      layout: "fitDataTable",
      height: (height - 150) + "px",
      movableColumns: true,
      initialSort: [
        { column: sort_column, dir: sort_dir }
      ],
      // columns
      columns: columns,
      // pagination
      pagination: "local",
      paginationSize: 25,
      paginationSizeSelector: [10, 25, 50],
      // Ajax
      ajaxURL: url,
      ajaxSorting: true,
      ajaxFiltering: true,
      ajaxLoader: true,
      ajaxLoaderLoading: "<div class='loader'> Loading...</div>",
      ajaxResponse: (url, params, response) => {
        this.updateIncomeTotals(response)
        return response.data || response
      }
    }

    table_props = Object.assign(default_props, table_props)
    // create table
    table_target.tabulator = new Tabulator(table_target, table_props)
    table_target.tabulator.setLocale(this.appLocale)
  }

  getIncomeColumns() {
    const columnsData = this.incomeTableTarget.getAttribute("data-table-columns")
    return JSON.parse(columnsData)
  }

  createConversionsTable() {
    const table_target = this.conversionsTableTarget
    const url = table_target.getAttribute("data-table-load-url")
    const columns = this.getConversionsColumns()
    const default_props = this.tabulatorDefaultProps
    const height = document.getElementById('content').clientHeight
    const sort_column = table_target.getAttribute("data-sort-column")
    const sort_dir = table_target.getAttribute("data-sort-dir")

    let table_props = {
      persistenceID: "z_report_conversions_table",
      layout: "fitDataTable",
      height: (height - 150) + "px",
      movableColumns: true,
      headerSort: false,
      // columns
      columns: columns,
      // Tree table configuration (no sorting - backend provides sorted data)
      dataTree: true,
      dataTreeStartExpanded: true,
      dataTreeBranchElement: false,
      dataTreeExpandElement: "<i class='fas fa-chevron-up mr-10'></i>",
      dataTreeCollapseElement: "<i class='fas fa-chevron-down mr-10'></i>",
      // Ajax
      ajaxURL: url,
      ajaxLoader: true,
      ajaxLoaderLoading: "<div class='loader'> Loading...</div>",
      ajaxResponse: function(url, params, response) {
        return response.data || response;
      },
      // Row formatting for status-based styling
      rowFormatter: function(row) {
        const data = row.getData();
        if (data.status) {
          row.getElement().classList.add("table-" + data.status)
        }
      },
      // Row click handler for tree toggle
      rowClick: function(e, row) {
        if (row.getData().status !== 'group_total') {
          row.treeToggle();
        }
      },
      // Show group totals when collapsed
      dataTreeRowCollapsed: function(row, level) {
        row.getElement().querySelectorAll(".group_row").forEach(function(el) {
          el.classList.remove('hidden');
        });
      },
      // Hide group totals when expanded
      dataTreeRowExpanded: function(row, level) {
        row.getElement().querySelectorAll(".group_row").forEach(function(el) {
          el.classList.add('hidden');
        });
      }
    }

    table_props = Object.assign(default_props, table_props)
    // create table
    table_target.tabulator = new Tabulator(table_target, table_props)
    table_target.tabulator.setLocale(this.appLocale)
  }

  getConversionsColumns() {
    const columnsData = this.conversionsTableTarget.getAttribute("data-table-columns")
    return JSON.parse(columnsData)
  }

  filterChanged(event) {
    event.preventDefault()
    this.updateTableFiltersDebounced()
  }

  updateTableFilters() {
    const dateRange = this.dateRangeTarget.value
    
    // Skip if date range hasn't actually changed
    if (dateRange === this.lastDateRange) {
      return
    }
    
    this.lastDateRange = dateRange
    
    // Update wallet balance table
    if (this.hasWalletBalanceTableTarget && this.walletBalanceTableTarget.tabulator) {
      const tableUrl = this.walletBalanceTableTarget.getAttribute("data-table-load-url")
      const url = new URL(tableUrl, window.location.origin)
      
      if (dateRange) {
        url.searchParams.set('date_range', dateRange)
      }
      
      this.walletBalanceTableTarget.tabulator.setData(url.toString())
    }
    
    // Update expenses table
    if (this.hasExpensesTableTarget && this.expensesTableTarget.tabulator) {
      const tableUrl = this.expensesTableTarget.getAttribute("data-table-load-url")
      const url = new URL(tableUrl, window.location.origin)
      
      if (dateRange) {
        url.searchParams.set('date_range', dateRange)
      }
      
      this.expensesTableTarget.tabulator.setData(url.toString())
    }

    // Update income table
    if (this.hasIncomeTableTarget && this.incomeTableTarget.tabulator) {
      const tableUrl = this.incomeTableTarget.getAttribute("data-table-load-url")
      const url = new URL(tableUrl, window.location.origin)
      
      if (dateRange) {
        url.searchParams.set('date_range', dateRange)
      }
      
      this.incomeTableTarget.tabulator.setData(url.toString())
    }

    // Update conversions table
    if (this.hasConversionsTableTarget && this.conversionsTableTarget.tabulator) {
      const tableUrl = this.conversionsTableTarget.getAttribute("data-table-load-url")
      const url = new URL(tableUrl, window.location.origin)
      
      if (dateRange) {
        url.searchParams.set('date_range', dateRange)
      }
      
      this.conversionsTableTarget.tabulator.setData(url.toString())
    }
  }

  exportClick(event) {
    event.preventDefault()
    const dateRange = this.dateRangeTarget.value
    const baseUrl = this.exportUrlTarget.href
    
    const url = new URL(baseUrl)
    if (dateRange) {
      url.searchParams.append('date_range', dateRange)
    }
    
    window.location.href = url.toString()
  }

  updateExpenseTotals(response) {
    const table = document.getElementById("expenses_table")
    if (!table || !response || !response.totals) return;

    const totals = response.totals
    table.setAttribute("data-total-usd", totals.usd || '')
    table.setAttribute("data-total-uzs", totals.uzs || '')
    table.setAttribute("data-total-eur", totals.eur || '')
    table.setAttribute("data-total-rub", totals.rub || '')
    table.setAttribute("data-total-usd-converted", totals.usd_converted || '')
  }

  updateIncomeTotals(response) {
    const table = document.getElementById("income_table")
    if (!table || !response || !response.totals) return;

    const totals = response.totals
    table.setAttribute("data-total-usd", totals.usd || '')
    table.setAttribute("data-total-uzs", totals.uzs || '')
    table.setAttribute("data-total-eur", totals.eur || '')
    table.setAttribute("data-total-rub", totals.rub || '')
    table.setAttribute("data-total-usd-converted", totals.usd_converted || '')
  }

  debounce(func, wait) {
    let timeout
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout)
        func(...args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }
  }
}